export default {
  hero: { eyebrow: 'Estudio de competiciones · Módulo premium', title: 'Crea competiciones de élite con la emoción de una retransmisión.', subtitle: 'Diseña experiencias de golf, raqueta e híbridas con espacios premium para patrocinadores, narrativa en tiempo real y flujos de control listos para el lanzamiento.' },
  actions: { create: 'Crear competición', creating: 'Creando…', demo: 'Iniciar modo de demostración', addScreen: 'Añadir pantalla', createGroup: 'Crear grupo de pantallas', newCampaign: 'Nueva campaña de patrocinio', previewBroadcast: 'Previsualizar retransmisión', startBroadcast: 'Iniciar retransmisión', pauseBroadcast: 'Pausar retransmisión', pushAnnouncement: 'Publicar anuncio', finalsMode: 'Activar modo finales' },
  metrics: { activeCompetitions: 'Competiciones activas', screensSynced: 'Pantallas sincronizadas', sponsorsLive: 'Patrocinadores en directo', viewersNow: 'Espectadores en directo (ahora)', totalScreens: 'Pantallas totales', onlineScreens: 'Pantallas conectadas', activeGroups: 'Grupos de pantallas activos', campaignsToday: 'Campañas activas hoy', tickerEnabled: 'Rótulo activado', broadcastingNow: 'Retransmitiendo ahora', matchesLive: 'Partidos en directo', activeBroadcasts: 'Retransmisiones activas', announcementsToday: 'Anuncios de hoy', spotlightEvents: 'Eventos destacados', viewers: 'Espectadores' },
  builder: { journey: 'Recorrido de configuración', readiness: '{value}% listo para el lanzamiento', tip: 'Consejo: la consola de lanzamiento se actualiza mientras diseñas el evento.', hybridHelp: 'Modo híbrido activado: diseña un flujo por fases con momentos de puntuación unificados.', golfPresetHelp: 'Selección de formatos de golf lista para el lanzamiento.', racquetPresetHelp: 'Selección de formatos de raqueta lista para el lanzamiento.', stageGolf: 'Fase 1: clasificación de golf', stageRacquet: 'Fase 2: cuadros de raqueta', stageFinals: 'Fase 3: finales unificadas' },
  formats: { matchPlayDescription: 'Duelo directo con emoción hoyo a hoyo.' },
  journey: { sport: 'Deporte', format: 'Formato', setup: 'Configuración', rules: 'Reglas', sponsors: 'Patrocinadores', launch: 'Lanzamiento' },
  screens: { eyebrow: 'Sala de control de retransmisión', title: 'Estudio de gestión de pantallas', subtitle: 'Controla todas las pantallas del recinto, rentabiliza los espacios de patrocinio y coordina una narrativa premium dentro del club.', lastSeen: 'Última conexión: {value}', noHeartbeat: 'Aún no se ha detectado actividad' },
  live: { title: 'Estudio de competiciones en directo', subtitle: 'Dirige partidos en directo, controla las retransmisiones y coordina la narrativa en tiempo real.' },
  announcements: { finalGroupCamera: 'El grupo final entra en la cobertura en directo del emblemático par 3.', courtTieBreak: 'La semifinal de la pista 1 entra en el desempate del set decisivo.', hospitalityOpen: 'La terraza de hospitality ya está abierta para los espectadores de las finales.' },
  spotlight: { onFire: 'En racha', closingHole: 'Hoyo final', bounceBack: 'Remontada en curso' },
  timeline: { ethanBirdie15: 'Birdie de Ethan en el 15', crowdSurge: 'Sube la expectación en la pista central', lucasReplay: 'Repetición del chip embocado de Lucas', semiFinalTieBreak: 'Comienza el desempate de la semifinal', spotlightHole16: 'El foco cambia al hoyo 16' },
  canonical: { sports: { golf: 'Golf', racquet: 'Raqueta', multiSport: 'Multideporte' }, statuses: { draft: 'Borrador', openForEntries: 'Inscripciones abiertas', entriesClosed: 'Inscripciones cerradas', inProgress: 'En curso', completed: 'Finalizada', cancelled: 'Cancelada' }, participants: { individual: 'Individual', team: 'Equipo', hybrid: 'Híbrido' }, broadcastModes: { leaderboardFocus: 'Enfoque de clasificación', matchFocus: 'Enfoque del partido', playerSpotlight: 'Jugador destacado', finalsMode: 'Modo finales' }, previewModes: { leaderboardFocus: 'Enfoque de clasificación', sponsorTicker: 'Rótulo de patrocinadores', matchCentre: 'Centro del partido', welcomeScreen: 'Pantalla de bienvenida', splitView: 'Vista dividida', sponsorAdvertCard: 'Tarjeta publicitaria del patrocinador', playerSpotlight: 'Jugador destacado' }, tickerThemes: { darkNeon: 'Neón oscuro', championshipGold: 'Dorado de campeonato', clubClassic: 'Clásico del club' }, tickerSpeeds: { slow: 'Lenta', standard: 'Estándar', fast: 'Rápida' }, matchStatuses: { live: 'En directo', upcoming: 'Próximo', completed: 'Finalizado' }, screenStatuses: { online: 'Conectada', offline: 'Desconectada' }, contestTypes: { closestToPin: 'Bola más cercana a bandera', longestDrive: 'Drive más largo' }, fantasyFormats: { salaryCap: 'Límite salarial', pickPlayers: 'Selección de jugadores' } },
  validation: { nameRequired: 'El nombre de la competición es obligatorio.', sportRequired: 'Selecciona un deporte.', typeRequired: 'Selecciona un tipo de competición.', startRequired: 'La fecha de inicio es obligatoria.', missingTitle: 'Faltan campos obligatorios', missingDescription: 'Completa los campos resaltados antes de crear la competición.' },
  errors: { create: 'No se ha podido crear la competición', review: 'Revisa los datos e inténtalo de nuevo.' },
  toasts: { created: 'Competición creada', createdDescription: 'La competición se ha guardado como borrador y está lista para los siguientes pasos.' },
  screenToasts: { missingClub: 'Falta el contexto del club', missingClubDescription: 'No se ha podido resolver el código del club.', createError: 'No se ha podido crear la pantalla', refreshError: 'No se ha podido actualizar el código', saveError: 'No se ha podido guardar la pantalla', updated: 'Pantalla actualizada', disconnectError: 'No se ha podido desconectar', disconnected: 'Dispositivo desconectado', reconnectError: 'No se ha podido generar el código de reconexión', retry: 'Inténtalo de nuevo.' },
  clipboard: { copied: 'Copiado', failed: 'No se ha podido copiar', manual: 'Copia el enlace manualmente.', screenLinkCopied: 'Enlace de pantalla copiado', linkFailed: 'No se ha podido copiar el enlace' },
  confirmations: { deleteContest: '¿Seguro que quieres eliminar este concurso?', removePlayer: '¿Seguro? Se eliminará al jugador de la competición.', overwritePairings: 'Se sobrescribirán los emparejamientos existentes. ¿Quieres continuar?', clearTeeTimes: 'Se borrarán todos los horarios de salida. ¿Quieres continuar?' },
  accessibility: { editContest: 'Editar concurso', deleteContest: 'Eliminar concurso', editEntry: 'Editar inscripción', deleteEntry: 'Eliminar inscripción', copyClubCode: 'Copiar código del club', copyPairingUrl: 'Copiar URL de vinculación', copyScreenUrl: 'Copiar URL de la pantalla' },
  preview: { assignedCompetition: 'Competición asignada', scheduledDay: 'Programada · Día 1 de 3', liveUpdates: 'Actualizaciones de la clasificación y puntuación en el campo en directo', presentedByPartners: 'Presentado por los colaboradores del club', presentedBy: 'Presentado por {sponsor}', dayProgress: 'Día {day} de {total}', tickerFallback: 'Rótulo de retransmisión de Privana · Próximamente habrá actualizaciones en directo', frontOfHouse: 'Recepción', awaitingAssignment: 'A la espera de asignar una competición', standby: 'En espera', graphicsReadyNext: 'Los gráficos de retransmisión están listos para el inicio de la próxima competición.', broadcast: 'Retransmisión de la competición', liveCoverage: 'Cobertura de la competición en directo', graphicsReady: 'Gráficos de retransmisión listos', clubhouse: 'Casa club', welcome: 'Bienvenido a The Privana Club', competitionUpdates: 'Actualizaciones de la competición en directo', stayTuned: 'Sigue atento a los cambios en la clasificación' },
  copy: {
    "competition_not_found": "No se ha encontrado la competición",
    "back_to_competitions": "Volver a Competiciones",
    "back_to_all_competitions": "Volver a todas las competiciones",
    "sponsored_by": "Patrocinado por:",
    "leaderboard": "Clasificación",
    "entries": "Inscripciones (",
    "tee_sheet": "Hoja de salidas",
    "contests": "Concursos",
    "fantasy": "Fantasy",
    "signage": "Señalización",
    "live_leaderboard": "Clasificación en directo",
    "no_scores_submitted_yet": "Aún no se han enviado resultados.",
    "pos": "Pos",
    "player": "Jugador",
    "h_cap": "Hándicap",
    "total": "Total",
    "live": "EN DIRECTO",
    "competition_feed": "Señal de competición",
    "venue": "Sede",
    "scoring_feed_connected_awaiting_first_results": "Señal de puntuación conectada · esperando los primeros resultados",
    "fantasy_leaderboard": "Clasificación Fantasy",
    "rank": "Posición",
    "member": "Socio",
    "team_name": "Nombre del equipo",
    "points": "Puntos",
    "fantasy_golf_setup": "Configuración de Fantasy Golf",
    "configure_the_fantasy_game_for_this_competition": "Configura el juego Fantasy para esta competición.",
    "edit_configuration": "Editar configuración",
    "format": "Formato:",
    "team_size": "Tamaño del equipo:",
    "captain": "Capitán:",
    "no_fantasy_game_configured_yet": "Aún no se ha configurado ningún juego Fantasy.",
    "fantasy_game_configuration": "Configuración del juego Fantasy",
    "team_size_2": "Tamaño del equipo",
    "picks_lock_time": "Hora de cierre de selecciones",
    "enable_captain_2x_points": "Activar capitán (2x puntos)",
    "prize_pool_description": "Descripción de la bolsa de premios",
    "cancel": "Cancelar",
    "save_configuration": "Guardar configuración",
    "on_course_contests": "Concursos en el campo",
    "manage_special_contests_like_longest_drive": "Gestiona concursos especiales, como el drive más largo.",
    "new_contest": "Nuevo concurso",
    "hole": "- Hoyo #",
    "winner": "Ganador:",
    "no_winner_declared_yet": "Aún no se ha declarado ningún ganador.",
    "no_on_course_contests_created_yet": "Aún no se han creado concursos en el campo.",
    "contest_type": "Tipo de concurso",
    "closest_to_the_pin": "Bola más cercana a bandera",
    "longest_drive": "Drive más largo",
    "hole_number": "Número de hoyo",
    "winner_2": "Ganador",
    "select_winner": "Seleccionar ganador",
    "none": "Ninguno",
    "result": "Resultado",
    "e_g_315_yards_or_3ft_2in": "p. ej., 315 yardas o 3 pies 2 pulgadas",
    "save_contest": "Guardar concurso",
    "template": "Plantilla",
    "device_preview": "Vista previa del dispositivo",
    "contest_winners": "Ganadores del concurso",
    "on_course_contest_results": "Resultados de concursos en el campo",
    "sponsored_by_2": "Patrocinado por",
    "contest_winners_will_be_announced_soon": "Los ganadores del concurso se anunciarán pronto.",
    "last_updated": "Última actualización:",
    "welcome_to_the": "Bienvenido a",
    "waiting_for_scores": "Esperando resultados…",
    "format_studio": "Estudio de formatos",
    "demo_ready": "Demostración lista",
    "hybrid_competition_flow": "Flujo de competición híbrida",
    "popular": "Popular",
    "competition_blueprint": "Configuración de la competición",
    "shape_identity_schedule_and_participation_with_a_broadcast_grade": "Define la identidad, el calendario y la participación con una configuración profesional de retransmisión.",
    "event_identity": "Identidad del evento",
    "competition_name": "Nombre de la competición",
    "privana_signature_invitational": "Invitacional Privana Signature",
    "short_description": "Descripción breve",
    "a_multi_discipline_premium_member_event_with_live_coverage": "Un evento multidisciplinar premium para socios, con cobertura en directo e integración de patrocinadores.",
    "venue_location": "Sede / ubicación",
    "championship_course_center_court": "Campo de campeonato + pista central",
    "schedule_participation": "Calendario y participación",
    "start_date": "Fecha de inicio",
    "end_date": "Fecha de fin",
    "max_participants": "Máximo de participantes",
    "mode": "Modo",
    "individual": "Individual",
    "team": "Equipo",
    "hybrid": "Híbrido",
    "rules_scoring_modules": "Módulos de reglas y puntuación",
    "compose_scoring_logic_blocks_that_feel_ready_for_real": "Configura bloques de puntuación preparados para operaciones reales.",
    "core_scoring_controls": "Controles principales de puntuación",
    "live_scoring_enabled": "Puntuación en directo activada",
    "gross_net_leaderboard": "Clasificación bruta y neta",
    "round_match_days": "Días de ronda o partido",
    "golf_engine": "Motor de golf",
    "handicap_allowances": "Ajustes de hándicap",
    "tie_break_policy": "Criterio de desempate",
    "back_nine": "Últimos nueve",
    "last_6_holes": "Últimos 6 hoyos",
    "sudden_death_playoff": "Desempate a muerte súbita",
    "racquet_engine": "Motor de deportes de raqueta",
    "set_format": "Formato de sets",
    "best_of_3": "Al mejor de 3",
    "best_of_5": "Al mejor de 5",
    "fast_4": "Fast 4",
    "points_structure": "Estructura de puntos",
    "standard": "Estándar",
    "golden_point_deuce": "Iguales con punto de oro",
    "timed_match_format": "Formato de partido cronometrado",
    "sponsorship_branding_studio": "Estudio de patrocinio e identidad visual",
    "competition_page": "Página de la competición",
    "tv_ticker": "Rótulo de TV",
    "screen_adverts": "Anuncios en pantalla",
    "screen_overlays": "Superposiciones en pantalla",
    "position_sponsor_inventory_across_pages_tickers_and_premium_screen": "Distribuye el inventario de patrocinio entre páginas, rótulos y pantallas premium.",
    "title_sponsor": "Patrocinador principal",
    "logo_media_slot": "Logotipo / Espacio multimedia",
    "1200x600_png_svg": "1200x600 · PNG/SVG",
    "supporting_sponsor_1": "Patrocinador colaborador 1",
    "supporting_sponsor_2": "Patrocinador colaborador 2",
    "commercial_surface_preview": "Vista previa de espacios comerciales",
    "competition_header": "Cabecera de la competición",
    "ticker_rotation": "Rotación del rótulo",
    "sponsor_loop": "BUCLE DE PATROCINADORES",
    "launch_console": "Consola de lanzamiento",
    "review_launch": "Revisión y lanzamiento",
    "your_premium_event_package_ready_for_broadcast_and_member": "Tu paquete premium del evento, listo para retransmitir y publicar a los socios.",
    "competition": "Competición",
    "saved_id": "ID guardado:",
    "max": "máx. ·",
    "launch_readiness": "Preparación para el lanzamiento",
    "all_required_launch_fields_are_complete": "Todos los campos obligatorios para el lanzamiento están completos.",
    "save_draft": "Guardar borrador",
    "preview_screens": "Previsualizar pantallas",
    "launch_confidence": "Confianza del lanzamiento:",
    "complete_identity_and_scheduling_fields_to_finalize_a_fully": "Completa la identidad y la programación para finalizar un paquete de competición totalmente preparado.",
    "screen_inventory": "Inventario de pantallas",
    "select_a_screen_to_load_its_live_preview_and": "Selecciona una pantalla para cargar su vista previa y sus controles.",
    "no_screens_added_yet": "Aún no se han añadido pantallas",
    "create_and_pair_your_first_competition_screen_to_unlock": "Crea y vincula tu primera pantalla de competición para habilitar el inventario en directo, la telemetría de estado y el control por zonas.",
    "one_time_pairing_flow_for_tvs_and_signage_laptops": "• Vinculación de un solo uso para televisores y portátiles de señalización",
    "persistent_screen_sessions_with_heartbeat_presence": "• Sesiones de pantalla persistentes con señal de actividad",
    "layout_and_sponsor_orchestration_from_one_control_room": "• Coordinación del diseño y los patrocinadores desde una única sala de control",
    "add_screen": "Añadir pantalla",
    "manage_screen": "Gestionar pantalla",
    "layout": "Diseño:",
    "source": "Fuente:",
    "ticker": "Rótulo:",
    "ad_loop": "Bucle de anuncios:",
    "live_preview_canvas": "Lienzo de vista previa en directo ·",
    "ticker_configuration": "Configuración del rótulo",
    "broadcast_footer_controls_for_sponsors_match_updates_and_urgent": "Controles del pie de retransmisión para patrocinadores, actualizaciones de partidos y anuncios urgentes.",
    "ticker_enabled": "Rótulo activado",
    "theme": "Tema",
    "speed": "Velocidad",
    "logo_mode": "Modo de logotipos",
    "sponsor_logos_only": "Solo logotipos de patrocinadores",
    "logos_text": "Logotipos + texto",
    "include_competition_updates": "Incluir actualizaciones de la competición",
    "urgent_announcements": "Anuncios urgentes",
    "ticker_sim_rolex_finals_countdown_court_1_live_in": "[Simulación de rótulo] Cuenta atrás para las finales Rolex · Pista 1 en directo en 04:00 · La presentación del colaborador de hospitality comienza a las 18:00.",
    "advert_scheduler_playlist": "Programador de anuncios y lista de reproducción",
    "design_sponsor_playback_loops_and_intermission_placements_with_commercial": "Diseña bucles de reproducción de patrocinadores y espacios en los intermedios con claridad comercial.",
    "assigned": "Asignada:",
    "playlist_timeline": "Cronología de la lista de reproducción",
    "screen_groups": "Grupos de pantallas",
    "deploy_synchronized_layouts_and_sponsor_packages_to_grouped_venue": "Despliega diseños sincronizados y paquetes de patrocinio en zonas agrupadas del recinto.",
    "screens": "pantallas ·",
    "active_campaigns": "campañas activas",
    "assign_layout": "Asignar diseño",
    "push_campaign": "Publicar campaña",
    "content_rotation_timeline": "Cronología de rotación de contenidos",
    "static_demo_loop_builder_showing_proportioned_broadcast_sequencing": "Constructor estático de bucles de demostración que muestra una secuencia de retransmisión proporcionada.",
    "s": "s",
    "loop_length": "Duración del bucle:",
    "s_auto_repeats_continuously_on_assigned_screens": "s · Se repite automáticamente y de forma continua en las pantallas asignadas.",
    "sponsor_campaign_manager": "Gestor de campañas de patrocinio",
    "sales_friendly_campaign_snapshots_for_sponsors_targets_frequencies_and": "Resúmenes comerciales de campañas con patrocinadores, destinos, frecuencias y prioridades.",
    "type": "Tipo:",
    "competition_2": "Competición:",
    "dates": "Fechas:",
    "targets": "Destinos:",
    "playback": "Reproducción:",
    "priority": "Prioridad:",
    "live_override_console": "Consola de intervención en directo",
    "instant_operational_controls_for_high_pressure_moments": "Controles operativos inmediatos para momentos de gran presión.",
    "add_competition_screen": "Añadir pantalla de competición",
    "create_a_screen_and_generate_a_short_lived_one": "Crea una pantalla y genera un código de vinculación de un solo uso y corta duración.",
    "pair_your_screen_first": "Vincula primero la pantalla",
    "follow_these_quick_steps_on_the_target_display_before": "Sigue estos pasos rápidos en la pantalla de destino antes de crearla.",
    "step_1_open_this_on_your_screen": "Paso 1 · Abre esta página en tu pantalla",
    "step_2_enter_your_club_code": "Paso 2 · Introduce el código de tu club",
    "screen_name_display_name": "Nombre de pantalla",
    "this_helps_your_team_identify_the_display_location_quickly": "Esto ayuda a tu equipo a identificar rápidamente la ubicación de la pantalla.",
    "active_one_time_code": "Código activo de un solo uso",
    "code_refreshes_in": "El código se actualiza en",
    "current_code_expires_at": "El código actual caduca a las",
    "club_code": "Código del club",
    "base_pairing_url": "URL base de vinculación",
    "unique_screen_url": "URL única de la pantalla",
    "open": "Abrir",
    "on_the_target_screen_enter_club_code": "en la pantalla de destino, introduce el código del club",
    "then_enter_the_one_time_code": ", y después introduce el código de un solo uso.",
    "done": "Listo",
    "edit_broadcast_behavior_and_device_state": "Edita el comportamiento de la retransmisión y el estado del dispositivo.",
    "display": "Pantalla",
    "display_name": "Nombre de la pantalla",
    "location": "Ubicación",
    "screen_link": "Enlace de la pantalla",
    "copy_the_direct_display_url_for_this_screen": "Copia la URL directa de visualización de esta pantalla.",
    "copy_screen_link": "Copiar enlace de la pantalla",
    "broadcast": "Retransmisión",
    "layout_preset": "Diseño preestablecido",
    "select_layout_preset": "Seleccionar diseño preestablecido",
    "unknown_preset_saved": "Diseño preestablecido desconocido (guardado):",
    "assigned_competition_id": "ID de la competición asignada",
    "device": "Dispositivo",
    "orientation": "Orientación",
    "resolution": "Resolución",
    "group_id": "ID del grupo",
    "messaging": "Mensajería",
    "standby_message": "Mensaje de espera",
    "toggles": "Opciones",
    "public_facing": "Visible al público",
    "reconnect_screen": "Volver a conectar la pantalla",
    "use_this_one_time_code_to_pair_the_existing": "Utiliza este código de un solo uso para volver a vincular la pantalla existente.",
    "one_time_code": "Código de un solo uso",
    "loading_managed_screens": "Cargando pantallas gestionadas…",
    "create_and_pair_your_first_screen_to_unlock_live": "Crea y vincula tu primera pantalla para habilitar el rótulo en directo, la programación de anuncios y los controles de diseño.",
    "live_match_selector": "Selector de partidos en directo",
    "choose_the_active_match_feed_for_command_operations": "Elige la señal del partido activo para las operaciones de control.",
    "status": "· Estado:",
    "broadcast_mode": "Modo de retransmisión",
    "select_mode": "Seleccionar modo",
    "player_spotlight": "Jugador destacado",
    "current_leader": "Líder actual ·",
    "featured_live": "· Destacado en directo",
    "live_ticker": "Rótulo en directo:",
    "leaderboard_control_panel": "Panel de control de clasificación",
    "match_control_panel": "Panel de control del partido",
    "announcements_panel": "Panel de anuncios",
    "type_announcement": "Escribe un anuncio…",
    "push_announcement": "Publicar anuncio",
    "spotlight_queue_panel": "Panel de cola de contenidos destacados",
    "push_to_broadcast": "Publicar en la retransmisión",
    "remove": "Eliminar",
    "match_timeline_panel": "Panel de cronología del partido",
    "live_sequence_of_score_updates_events_and_highlight_triggers": "Secuencia en directo de actualizaciones de resultados, eventos y activadores de momentos destacados.",
    "production_critical_actions_for_high_pressure_broadcast_control": "Acciones esenciales de producción para controlar la retransmisión en momentos de gran presión.",
    "manage_pairings_and_tee_times": "Gestiona los emparejamientos y horarios de salida.",
    "auto_generate": "Generar automáticamente",
    "clear_sheet": "Limpiar hoja",
    "tee_time": "Hora de salida",
    "players": "Jugadores",
    "tee_sheet_has_not_been_generated": "La hoja de salidas aún no se ha generado.",
    "search_members": "Buscar socios…",
    "no_members_found": "No se han encontrado socios.",
    "selected": "Seleccionados:",
    "competition_entries": "Inscripciones de la competición",
    "manage_participants_for_this_event": "Gestiona los participantes de este evento.",
    "add_participants": "Añadir participantes",
    "player_name": "Nombre del jugador",
    "h_cap_index": "Índice de hándicap",
    "playing_h_cap": "Hándicap de juego",
    "payment": "Pago",
    "actions": "Acciones",
    "no_entries_yet": "Aún no hay inscripciones.",
    "edit_entry": "Editar inscripción",
    "handicap_index": "Índice de hándicap",
    "save_changes": "Guardar cambios",
    "add_new_participants": "Añadir participantes",
    "members": "Socios",
    "h_cap_index_2": "Índice de hándicap",
    "next": "Siguiente",
    "back": "Volver",
    "save_participants": "Guardar participantes",
    "starting_times": "Horarios de salida",
    "tee_times_have_not_been_assigned_yet": "Los horarios de salida aún no se han asignado.",
    "golf": "Golf",
    "precision_scoring_and_marquee_course_storytelling": "Puntuación precisa y narrativa destacada del campo.",
    "ideal_for_member_majors_invitationals_and_broadcast_ready_rounds": "Ideal para grandes torneos de socios, invitacionales y rondas listas para retransmitir.",
    "racquet": "Raqueta",
    "tennis_padel_and_racquet_leagues_in_one_flow": "Tenis, pádel y ligas de raqueta en un único flujo.",
    "built_for_ladders_tournaments_and_club_vs_club_showcases": "Diseñado para rankings, torneos y encuentros entre clubes.",
    "multi_sport": "Multideporte",
    "a_premium_hybrid_event_engine_for_signature_championships": "Un motor premium de eventos híbridos para campeonatos emblemáticos.",
    "combine_golf_racquet_stages_with_unified_club_wide_storytelling": "Combina fases de golf y raqueta con una narrativa unificada para todo el club.",
    "stableford": "Stableford",
    "points_by_hole_with_handicap_friendly_pacing": "Puntos por hoyo con un ritmo adaptado al hándicap.",
    "strategic_fast": "Estratégico · Rápido",
    "stroke_play": "Juego por golpes",
    "classic_aggregate_scoring_across_rounds": "Puntuación clásica acumulada a lo largo de las rondas.",
    "traditional_premium": "Tradicional · Premium",
    "match_play": "Juego por hoyos",
    "dramatic_broadcast": "Emocionante · Retransmisión",
    "best_ball_scramble": "Scramble a mejor bola",
    "team_creativity_with_best_shot_selection": "Creatividad por equipos con selección del mejor golpe.",
    "social_team_energy": "Social · Energía de equipo",
    "wolf": "Wolf",
    "rotating_strategy_and_decision_pressure_each_hole": "Estrategia rotativa y decisiones bajo presión en cada hoyo.",
    "dynamic_interactive": "Dinámico · Interactivo",
    "round_robin": "Liga de todos contra todos",
    "balanced_fixture_grid_with_standings_momentum": "Calendario equilibrado que mantiene el dinamismo de la clasificación.",
    "fair_consistent": "Justo · Consistente",
    "knockout": "Eliminación directa",
    "single_elimination_bracket_with_spotlight_matches": "Cuadro de eliminación directa con partidos destacados.",
    "fast_high_stakes": "Rápido · Máxima exigencia",
    "double_elimination": "Doble eliminación",
    "second_life_pathway_with_stronger_parity": "Una segunda oportunidad con mayor equilibrio competitivo.",
    "competitive_extended": "Competitivo · Prolongado",
    "ladder_league": "Liga por ranking",
    "challenge_ladder_for_season_long_movement": "Ranking de retos con progresión durante toda la temporada.",
    "persistent_engaging": "Continuo · Atractivo",
    "team_league": "Liga por equipos",
    "squad_fixtures_with_tactical_lineups": "Encuentros por equipos con alineaciones tácticas.",
    "club_pride_tactical": "Orgullo de club · Táctico",
    "sport": "Deporte",
    "format_2": "Formato",
    "setup": "Configuración",
    "rules": "Reglas",
    "sponsors": "Patrocinadores",
    "launch": "Lanzamiento",
    "layout_1": "Diseño 1",
    "main_feed_with_right_side_leaderboard_rail_and_live": "Señal principal con clasificación lateral derecha y rótulo inferior en directo",
    "leaderboard_focus": "Enfoque de clasificación",
    "sponsor_ticker": "Rótulo de patrocinadores",
    "match_centre": "Centro del partido",
    "welcome_screen": "Pantalla de bienvenida",
    "split_view": "Vista dividida",
    "sponsor_advert_card": "Tarjeta publicitaria del patrocinador",
    "video_advert": "Anuncio de vídeo",
    "every_3_mins": "Cada 3 min",
    "live_2": "En directo",
    "bar_lounge_lobby": "Bar y salón, vestíbulo",
    "image_advert": "Anuncio de imagen",
    "every_loop": "En cada bucle",
    "queued": "En cola",
    "golf_areas": "Zonas de golf",
    "full_screen_takeover": "Ocupación de pantalla completa",
    "top_of_hour": "Al inicio de cada hora",
    "all_public_screens": "Todas las pantallas públicas",
    "intermission_card": "Tarjeta de intermedio",
    "between_matches": "Entre partidos",
    "draft": "Borrador",
    "racquet_areas": "Zonas de deportes de raqueta",
    "sponsor_slate": "Cartela del patrocinador",
    "every_5_mins": "Cada 5 min",
    "reception_lobby": "Recepción y vestíbulo",
    "bar_lounge": "Bar y salón",
    "leaderboard_focus_2": "Enfoque de clasificación",
    "reception_lobby_2": "Recepción y vestíbulo",
    "welcome_screen_2": "Pantalla de bienvenida",
    "golf_areas_2": "Zonas de golf",
    "clubhouse_mixed_feed": "Señal mixta de la casa club",
    "racquet_areas_2": "Zonas de deportes de raqueta",
    "match_centre_2": "Centro del partido",
    "all_public_screens_2": "Todas las pantallas públicas",
    "finals_day_mode": "Modo día de finales",
    "fixtures": "Encuentros",
    "sponsor_reel": "Vídeo de patrocinadores",
    "match_spotlight": "Partido destacado",
    "club_promo": "Promoción del club",
    "premium_brand_loop": "Bucle de marcas premium",
    "all_public_screens_3": "Todas las pantallas públicas",
    "every_4_mins": "Cada 4 min",
    "active": "Activo",
    "equipment_launch": "Lanzamiento de equipamiento",
    "golf_areas_3": "Zonas de golf",
    "every_6_mins": "Cada 6 min",
    "lifestyle_spotlight": "Estilo de vida destacado",
    "bar_lounge_2": "Bar y salón",
    "hourly_takeover": "Ocupación cada hora",
    "scheduled": "Programada",
    "wellness_card": "Tarjeta de bienestar",
    "racquet_areas_3": "Zonas de deportes de raqueta",
    "every_loop_2": "En cada bucle",
    "leaderboard_focus_3": "Enfoque de clasificación",
    "live_leaderboard_dominance": "Protagonismo de la clasificación en directo",
    "scores_stay_central_with_a_compact_sponsor_ribbon_and": "Los resultados ocupan el centro, con una banda compacta de patrocinadores y un pie preparado para la rotación.",
    "sponsor_ticker_2": "Rótulo de patrocinadores",
    "sponsor_led_ticker_mode": "Modo de rótulo centrado en patrocinadores",
    "commercial_headlines_lead_the_footer_while_updates_pulse_between": "Los titulares comerciales encabezan el pie mientras las actualizaciones aparecen entre las inserciones.",
    "match_centre_3": "Centro del partido",
    "match_centre_telemetry": "Telemetría del centro del partido",
    "fixture_cards_and_live_status_widgets_prioritize_active_court": "Las tarjetas de encuentros y los indicadores de estado en directo priorizan los momentos activos en pista y campo.",
    "welcome_screen_3": "Pantalla de bienvenida",
    "arrival_and_welcome_ambience": "Ambiente de llegada y bienvenida",
    "hero_greeting_weather_highlights_and_next_tee_times_greet": "Una bienvenida destacada, el tiempo y las próximas salidas reciben a los socios.",
    "split_view_2": "Vista dividida",
    "dual_feed_split_view": "Vista dividida de doble señal",
    "competition_feed_runs_beside_sponsor_inventory_for_balanced_engagement": "La señal de competición comparte espacio con el inventario de patrocinio para equilibrar la atención.",
    "sponsor_advert_card_2": "Tarjeta publicitaria del patrocinador",
    "full_sponsor_card_feature": "Presentación completa del patrocinador",
    "high_impact_sponsor_creative_sits_front_and_center_with": "La creatividad de alto impacto del patrocinador ocupa el centro con un marco premium.",
    "player_spotlight_mode": "Modo de jugador destacado",
    "athlete_profile_treatment_with_live_ranking_and_next_up": "Perfil del deportista con clasificación en directo y avisos del siguiente participante.",
    "final_group_hole_16": "Grupo final · Hoyo 16",
    "court_1_semi_final": "Pista 1 · Semifinal",
    "final_group_hole_12": "Grupo final · Hoyo 12",
    "court_2_quarter_final": "Pista 2 · Cuartos de final",
    "final_group_hole_8": "Grupo final · Hoyo 8",
    "final_group_entering_signature_par_3_live_camera_window": "El grupo final entra en la cobertura en directo del emblemático par 3.",
    "court_1_semi_final_entering_decisive_set_tie_break": "La semifinal de la pista 1 entra en el desempate del set decisivo.",
    "hospitality_terrace_now_open_for_finals_spectators": "La terraza de hospitality ya está abierta para los espectadores de las finales.",
    "on_fire": "En racha",
    "closing_hole": "Hoyo final",
    "bounce_back_momentum": "Impulso de la remontada",
    "ethan_birdie_on_15": "Birdie de Ethan en el 15",
    "crowd_surge_at_center_court": "Sube la expectación en la pista central",
    "lucas_chip_in_replay": "Repetición del chip embocado de Lucas",
    "semi_final_tie_break_begins": "Comienza el desempate de la semifinal",
    "spotlight_switch_to_hole_16": "El foco cambia al hoyo 16",
    "leaderboard_focus_4": "Enfoque de clasificación",
    "match_focus": "Enfoque del partido",
    "finals_mode": "Modo finales"
  }
};
